import { Button, Textarea } from '@mantine/core';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import React from 'react';
import { useNavigate } from 'react-router';
import { generatePath } from 'react-router-dom';

import { rootRoutes } from '../../../../app/routers/rootRoutes';
import { useUpdateTaskMutation } from '../../../../entities/tasks/model/api/taskApi';
import { texts } from '../../../../shared/config';
import { TaskActionDto } from '../../../../shared/model/tasks/types';
import { ContentLayout } from '../../../../shared/ui/ContentLayout';
import { TaskActions } from '../../../../shared/ui/TaskActions';

interface FormValues {
  comment: string;
}

type Props = {
  taskId: string;
  actionField: TaskActionDto;
};

export const TaskComment: React.FC<Props> = ({ actionField, taskId }) => {
  const navigate = useNavigate();
  const [updateTask, result] = useUpdateTaskMutation();

  const form = useForm({
    mode: 'uncontrolled',
    name: 'comment',
    initialValues: {
      comment: '',
    },
    validate: (values) => ({
      comment:
        actionField.request_commentField === '0' || values.comment.trim() ? null : 'Необходимо ввести комментарий',
    }),
    validateInputOnChange: true,
  });

  const handleSubmit = ({ comment }: FormValues) => {
    updateTask({
      data: {
        comment,
        action_id: actionField.idField,
        adduser_id: null,
        answers_id: 0,
        task_id: taskId!,
      },
    })
      .unwrap()
      .then(() => {
        notifications.show({
          message: texts.requestSusses,
        });
        handleCancelClick();
      })
      .catch((error) => {
        notifications.show({
          message: error.data?.UpdateTaskResult?.error ?? texts.requestError,
          color: 'red',
        });
      });
  };

  const handleCancelClick = () => {
    navigate(generatePath(rootRoutes.task, { taskId }));
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <ContentLayout withActions dataId="taskCommentContent">
        <Textarea disabled={result.isLoading} {...form.getInputProps('comment')} autoFocus />
      </ContentLayout>
      <TaskActions dataId="taskCommentActions">
        <Button disabled={result.isLoading} variant="outline" onClick={handleCancelClick}>
          Отмена
        </Button>
        <Button loading={result.isLoading} type="submit">
          Отправить
        </Button>
      </TaskActions>
    </form>
  );
};
